import React from "react";
import useAuth from "../hooks/useAuth";
import { Redirect } from "react-router-dom";
import PropTypes from "prop-types";

const PasswordGuard = ({ children }) => {
  const { isAuthenticated, user } = useAuth();

  if (!isAuthenticated) {
    return <Redirect to="/login" />;
  }

  return <>{children}</>;
};

PasswordGuard.propTypes = {
  children: PropTypes.node
};

export default PasswordGuard;
